<div class="form-element relative">
	<mat-label for="form-type">{{ label }}</mat-label>
	<mat-form-field
		appearance="outline"
		class="form-field-responsive mt-1 w-full"
		[class.mat-form-field-invalid]="field.touched && field.invalid"
	>
		<input
			type="text"
			#inputField
			placeholder="{{ placeholder }}"
			matInput
			[formControl]="autoCompleteInput"
			[matAutocomplete]="auto"
			(keydown)="onInputKeydown($event)"
			(paste)="onInputPaste($event)"
			(click)="onInputClick()"
			(focusout)="autocompleteFocusOut()"
			[readonly]="readonly"
			[class.cbta-autocomplete-select-only]="selectOnly"
			#autocompleteTrigger="matAutocompleteTrigger"
		/>
		@if (clearable && autoCompleteInput.value && !autoCompleteInput.disabled) {
			<button matSuffix mat-icon-button aria-label="Clear" (click)="clearInupt()" class="!size-[unset] !p-2">
				<span class="aa-mat-icon">close</span>
			</button>
		}
		<span matSuffix class="aa-mat-icon mr-4">keyboard_arrow_down</span>
		<mat-autocomplete
			#auto="matAutocomplete"
			(optionSelected)="onSelectionChange($event)"
			[displayWith]="displayFn"
			[panelWidth]="panelWidth"
		>
			@for (option of fromTypeOptions | async; track option) {
				<mat-option [value]="option">
					{{ option.description }}
				</mat-option>
			}
		</mat-autocomplete>
		@if (isFieldHasError) {
			<mat-error>
				{{ sharedService.getErrorMessage(field) }}
			</mat-error>
		}
	</mat-form-field>
	<!-- @if (!isDisabled && field.value != "") {
		<div class="absolute right-6 top-1/2 -translate-y-6">
			<button matSuffix mat-icon-button aria-label="Clear" (click)="clearInupt()">
				<span class="aa-mat-icon">close</span>
			</button>
		</div>
	} -->
</div>
